<script>
    import SignUp from "../../Pages/Auth/SignUp.svelte";
</script>

<div class="flex flex-col flex-1 w-full align-left">
    <SignUp />
</div>
